import { FlowStage } from "./novel.type";

export const DOCS: FlowStage[] = [
  {
    phaseKey: "Follow for more updates",
    phaseTitle: "Follow for more updates",
    phaseTasks: [
      {
        name: "", label: "Twitter @arihantcodes",
        value: "Twitter @arihantcodes",
        url: "https://x.com/arihantCodes",
      },
    ],
  },
  {
    phaseKey: "gettingStart",
    phaseTitle: "Getting Started",
    phaseTasks: [
      {
        name: "", label: "Introduction",
        value: "introduction",
        url: "/docs",
      },
      {
        name: "", label: "Installation",
        value: "installation",
        url: "/novel#installation",
      },
      {
        name: "", label: "Animated SVG Chart",
        value: "animatedchart",
        url: "/novel#animatedchart",
      },
      {
        name: "", label: "Animated Testimonials",
        value: "animatedtestimonials",
        url: "/novel#animatedtestimonials",
      },
      {
        name: "", label: "Autosize Textarea",
        value: "autosize-textarea",
        url: "/novel#autosize-textarea",
      },
      { name: "", label: "Button", value: "button", url: "/novel#button", },
      { name: "", label: "Card", value: "card", url: "/novel#card" ,    },
      {
        name: "", label: "Datetime Picker",
        value: "datetime-picker",
        url: "/novel#datetime-picker",
      },
      {
        name: "", label: "Disclose Image",
        value: "discloseimage",
        url: "/novel#discloseimage",
      },
    ],
  },
  {
    phaseKey: "components",
    phaseTitle: "Components",
    phaseTasks: [
      { name: "", label: "Alert", value: "alert", url: "/novel#alert", new: true },
      {
        name: "", label: "Animated SVG Chart",
        value: "animatedchart",
        url: "/novel#animatedchart",
      },
      {
        name: "", label: "Animated Testimonials",
        value: "animatedtestimonials",
        url: "/novel#animatedtestimonials",
      },
      {
        name: "", label: "Autosize Textarea",
        value: "autosize-textarea",
        url: "/novel#autosize-textarea",
      },
      { name: "", label: "Button", value: "button", url: "/novel#button", },
      { name: "", label: "Card", value: "card", url: "/novel#card" ,    },
      {
        name: "", label: "Datetime Picker",
        value: "datetime-picker",
        url: "/novel#datetime-picker",
      },
      {
        name: "", label: "Disclose Image",
        value: "discloseimage",
        url: "/novel#discloseimage",
      },
      {
        name: "", label: "Dual Range Slider",
        value: "dual-range-slider",
        url: "/novel#dual-range-slider",
      },
      {
        name: "", label: "Event Calendar",
        value: "eventcalendar",
        url: "/novel#eventcalendar",
   
      },
      {
        name: "", label: "Feadback Card",
        value: "feadback",
        url: "/novel#feadback",
        new: true,
      },
      {
        name: "", label: "Floating Label Input",
        value: "floating-label-input",
        url: "/novel#floating-label-input",
      },
      { name: "", label: "Footer", value: "footer", url: "/novel#footer" ,},
      {
        name: "", label: "HTTP Status Code",
        value: "statuscode",
        url: "/novel#statuscode",
      },
      {
        name: "", label: "Image Preview",
        value: "imagepreview",
        url: "/novel#imagepreview",

      },
      {
        name: "", label: "Infinite Scroll",
        value: "infiniteScroll",
        url: "/novel#infinite-scroll",
      },
      { name: "", label: "Input", value: "input", url: "/novel#input", },
      {
        name: "", label: "Loading Button",
        value: "loading-button",
        url: "/novel#loading-button",
      },
      {
        name: "", label: "Multiple Selector",
        value: "multipleSelector",
        url: "/novel#multiple-selector",
      },
      { name: "", label: "Navbar", value: "navbar", url: "/novel#navbar" ,    new: true,},
      {
        name: "", label: "Progress With Value",
        value: "progress-with-value",
        url: "/novel#progress-with-value",
      },
      {
        name: "", label: "Responsive Modal",
        value: "responsive-modal",
        url: "/novel#responsive-modal",
      },
      { name: "", label: "Spinner", value: "spinner", url: "/novel#spinner" },
      {
        name: "", label: "Skeleton",
        value: "skeleton",
        url: "/novel#skeleton",
     
      },
    ],
  },
];
